import { render, staticRenderFns } from "./KolnHowTo.vue?vue&type=template&id=b699dd7c&scoped=true&"
import script from "./KolnHowTo.vue?vue&type=script&lang=js&"
export * from "./KolnHowTo.vue?vue&type=script&lang=js&"
import style0 from "./KolnHowTo.vue?vue&type=style&index=0&id=b699dd7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b699dd7c",
  null
  
)

export default component.exports